import { AnyAction } from 'store/state'
import { ACTION_IMPERSONATE_STOP, startImpersonation } from './impersonate/actions'
import { AdminState, initialState } from './state'

export function adminReducer(state = initialState(), action: AnyAction): AdminState {
  switch (action.type) {
    case startImpersonation.type:
      const { userId, fullName, accessToken } = action.payload.user
      return {
        ...state,
        impersonate: {
          userId,
          name: fullName,
          token: accessToken,
          productInfo: action.payload.productInfo
        }
      }

    case ACTION_IMPERSONATE_STOP:
      return { ...state, impersonate: undefined }

    default:
      return state
  }
}

export default adminReducer
